import { createFileRoute } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";
import { useSuspenseGraphQL } from "@/hooks/use-graphql.ts";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { SecretaryDetailsProfessionalInfosForm } from "@/components/assist/secretary-details/professional-infos-form";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetSecretaryProfessionalInfosQuery = graphql(/* GraphQL */ `
  query GetSecretaryProfessionalInfosQuery {
    ...SecretaryDetailsProfessionalInfosFormFragment
  }
`);

const ProfessionalInfosPage = (): React.ReactNode => {
  const { data } = useSuspenseGraphQL(GetSecretaryProfessionalInfosQuery, {});
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="" align="center" />
      </HeaderRoot>
      <Page>
        <SecretaryDetailsProfessionalInfosForm data={data} />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/assist/secretary-details/professional-infos",
)({
  component: ProfessionalInfosPage,
  pendingComponent: () => <PendingComponent title="" />,
});
